// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterMainTitle_root__uQwwK","badge":"FilterMainTitle_badge__xJWA6","icon":"FilterMainTitle_icon__QQkYy","title":"FilterMainTitle_title__T2qH6"};